// extracted by mini-css-extract-plugin
export var chevronIcon = "_cv-2";
export var teamName = "_cv-1";
export var teamSwitcherButton = "_cv-0";